import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  Badge,
  Icon,
} from '@folio/stripes/components';

import { useHealthCheck } from '../../hooks/useSmartHelp';

import css from './ConnectionStatus.css';

const propTypes = {
  showLabel: PropTypes.bool,
};

const defaultProps = {
  showLabel: true,
};

const ConnectionStatus = ({ showLabel }) => {
  const intl = useIntl();
  const { data: healthData, isLoading, error } = useHealthCheck();

  const isConnected = healthData?.success && healthData?.data?.status === 'healthy';
  const isChecking = isLoading;

  const getStatusColor = () => {
    if (isChecking) return 'default';
    return isConnected ? 'success' : 'error';
  };

  const getStatusIcon = () => {
    if (isChecking) return 'clock';
    return isConnected ? 'check-circle' : 'exclamation-circle';
  };

  const getStatusText = () => {
    if (isChecking) {
      return intl.formatMessage({ id: 'ui-plugin-smart-help.status.checking' });
    }
    return isConnected
      ? intl.formatMessage({ id: 'ui-plugin-smart-help.status.connected' })
      : intl.formatMessage({ id: 'ui-plugin-smart-help.status.disconnected' });
  };

  return (
    <div className={css.connectionStatus}>
      <Badge color={getStatusColor()}>
        <Icon icon={getStatusIcon()} size="small" />
        {showLabel && <span className={css.statusText}>{getStatusText()}</span>}
      </Badge>
    </div>
  );
};

ConnectionStatus.propTypes = propTypes;
ConnectionStatus.defaultProps = defaultProps;

export default ConnectionStatus;